const SpinnerLoader = () => {
    return (
        <div className='full-page-loader'>
            <div className="loader-main">
                <div className="loader-inner"></div>

            </div>

        </div>
    );
};

export default SpinnerLoader;
